// extracted by css-extract-rspack-plugin
export default {"Mascot":"Mascot-module__Mascot__GNVbOrf","Animate":"Mascot-module__Animate__eGrx1wj","Image":"Mascot-module__Image___vjr_aI","Shadow":"Mascot-module__Shadow__kMCg0fB"};